import React from "react";
import Select from "react-select";
import { useThemeChange } from "../../utils/themeChange";

import { darkCustomStyles, lightCustomStyles } from "./customStyles";

const SingleSelect = ({
  value,
  options,
  handleSelect,
  onMenuOpen,
  disable,
}) => {
  const { theme } = useThemeChange();
  return (
    <Select
      styles={theme === "dark" ? darkCustomStyles : lightCustomStyles}
      value={value}
      onChange={handleSelect}
      options={options}
      menuContainerStyle={{ zIndex: 999 }}
      onMenuOpen={onMenuOpen}
      isDisabled={disable}
    />
  );
};

export default SingleSelect;
